import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { useUser } from "@/features/auth/hooks/use-user";
import { GymPage } from "@/features/booking/modules/gym-page/gym-page";
import { m } from "@/paraglide/messages.js";

/**
 * The directory gym the business trains at. Business settings link here, and so do the
 * notifications about the hours and equipment its coaches proposed (`?placeId=`).
 */
export const Route = createFileRoute("/(private)/booking/gym/")({
  loader: () => ({ crumb: m.booking_gym_page_title() }),
  validateSearch: z.object({ placeId: z.string().optional(), bookingId: z.string().optional() }),
  component: GymRoute,
});

function GymRoute() {
  const { hasPermission } = useUser();
  const { placeId } = Route.useSearch();

  return <GymPage placeId={placeId} canPropose={hasPermission("manage", "booking_settings")} />;
}
